import  Style                       from "components/UI/main.module.scss";
import  React, { useState, useEffect } from 'react';
import { q3x_FunData, GetSystemLabel }    from "Utilities/utils";
import {InputGeneral}               from "components/Field/field";
import { Select }                   from "antd";
import {GetSeferData}               from "SeferPetach/GetData";

async function getUserHelp(data) {
    var payload = await GetSeferData("gethelp", {...data});
    return (payload);
}

const DropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
    dropdownStyle,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
        dropdownStyle={dropdownStyle}
      />
    );
};
const Content = ({messageObj, handleChange}) => {
  return(
    <div className={Style.m_3}>
      <CartisanYSpace>
        <span className={[Style.text_body, Style.fs_8,  Style.text_wrap, Style.fw_semibold].join(" ")} >
          {GetSystemLabel("TicketSupportHeader")}
        </span>
      </CartisanYSpace>
      <CartisanYSpace>
        <span className={[Style.text_body, Style.fs_8, Style.text_wrap].join(" ")} >
          {GetSystemLabel("TicketSupportBody")}
        </span>
      </CartisanYSpace>
      <CartisanYSpace>
        <span className={[Style.text_body, Style.fs_8, Style.text_wrap].join(" ")} >
          {GetSystemLabel("TicketSupportLabelCategory")}
        </span>
      </CartisanYSpace>
      <CartisanYSpace>
        <DropdownList
            value={messageObj.CategoryId > 0 ? parseInt(messageObj.CategoryId) : null}
            placeholder={""}                                
            listOfItems={[  {value: 1, label: GetSystemLabel("TicketSupportLabelCategoryOptionSuggestion")},
                            {value: 2, label: GetSystemLabel("TicketSupportLabelCategoryOptionHelp")}
            ]}
            style={{ width: "100%" }}  
            className={Style.text_input}                               
            popupClassName={Style.text_input}                              
            onChange={(event) => handleChange({CategoryId: (event)})}
            dropdownStyle={{ zIndex: 999999 }}
        />
      </CartisanYSpace>    
      <CartisanYSpace>
        <span className={[Style.text_body, Style.fs_8, Style.text_wrap].join(" ")} >
          {GetSystemLabel("TicketSupportLabelRequest")}
        </span>
      </CartisanYSpace>
      <CartisanYSpace>
        <InputGeneral 
            autoSize={true}
            value={messageObj.Content}
            className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
            onChange={(event) => handleChange({Content: q3x_FunData(event.target.value)})}
            maxLength={500}
        />
      </CartisanYSpace>
  </div>
  );
};
const CartisanYSpace  = ({children}) => {
  return(
    <div className={Style.my_2}>
      {children}
    </div>
  );
};

export const HelpModal = () => {
  const [ expanded,   setExpanded]       = useState(false);
  const [ height,     setHeight]         = useState(0);
  const [ overFlow,   setOverFlow]       = useState("hidden");
  const [ messageObj, setMessageObj]     = useState({CategoryId: null, Content: ""});
  const [ sended,     setSended]         = useState(false);

  const handleChange = (updatedValues) => {
      const mergedValues = {
          ...messageObj,
          ...updatedValues
      };
      setMessageObj(mergedValues);
  };
  const toggleExpand = () => {
    if (expanded) {
        setExpanded(false);
        setHeight(0); 
        setOverFlow("hidden");
    } else {
        setExpanded(true);
        setHeight(45);
        setOverFlow("scroll");
    }
  };
  const NewRequest = () => {
    try {
        setMessageObj({CategoryId: null, Content: ""});
        setSended(false);
    }
    catch(err) {          
      console.error(err);
    }    
  };
  const fetchHelpData = async () => {
    try {
      let data = await getUserHelp(messageObj);
      if (data) {
          if (data?.Status?.Code == 0) {
            setSended(true);
          }
      }
    }
    catch(err) {          
      console.error(err);
    }
  };

  return (
    <React.Fragment>
      <div style={{ position: 'fixed', bottom: '0px', zIndex: '10000'}}>
        <div className={Style.d_flex}>
            <div  onClick={() => {toggleExpand();}} className={[Style.rounded_top_2, Style.card_header_bg, Style.border, Style.shadow_sm, Style.clickable].join(" ")}>
              <div className={[Style.m_2].join(" ")}>
                <span className={[Style.text_body, Style.fs_8].join(" ")} >
                  {GetSystemLabel("TicketSupportLabel")}
                </span>
              </div>
            </div>
        </div>
        <div
              className={[
                Style.d_flex,
                Style.card_bg,
                Style.justify_content_start,
                expanded ? Style.border_end : "",
                expanded ? Style.border_top : ""
              ].join(" ")}
        >
          <div  
                style={{
                    height: `${Math.floor(height / 2.0)}rem`,
                    overflowY: `${overFlow}`,
                    transition: 'height 0.1s linear',
                    width: expanded ? '20rem' : '0'
                  }}
          >            
            {!sended && (
              <React.Fragment>
                <Content messageObj={messageObj} handleChange={handleChange}/>
                <CartisanYSpace>
                    <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_middle].join(" ")}>
                            <div  style={{width: '40%'}}
                                className={[    Style.vanilla_bg,
                                                Style.clickable,
                                                Style.rounded_2, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.fs_8, 
                                                Style.text_body,
                                                Style.text_center,
                                                Style.pop_item_animation].join(" ")}
                                onClick={() => {fetchHelpData()}}
                            >
                                <div className={Style.py_2}>
                                    {GetSystemLabel("Send")}
                                </div>
                            </div>
                    </div>
                </CartisanYSpace>
              </React.Fragment>
            )}
            {sended && (
              <React.Fragment>
                <div className={Style.m_3}>
                  <CartisanYSpace>
                    <span className={[Style.text_body, Style.fs_8,  Style.text_wrap, Style.fw_semibold].join(" ")} >
                      {GetSystemLabel("TicketSupportReturnHeader")}
                    </span>
                  </CartisanYSpace>
                  <CartisanYSpace>
                    <span className={[Style.text_body, Style.fs_8,  Style.text_wrap].join(" ")} >
                      {GetSystemLabel("TicketSupportReturnBody")}
                    </span>
                  </CartisanYSpace>
                </div>
                <CartisanYSpace>
                    <div className={[Style.d_flex, Style.justify_content_center, Style.align_middle].join(" ")}>
                        <div  style={{width: '40%'}}
                            className={[    Style.vanilla_bg,
                                            Style.clickable,
                                            Style.rounded_2, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.fs_8, 
                                            Style.text_body,
                                            Style.text_center,
                                            Style.pop_item_animation].join(" ")}
                            onClick={() => {toggleExpand();}}
                        >
                            <div className={Style.py_2}>
                                {GetSystemLabel("Close")}
                            </div>
                        </div>
                    </div>                    
                </CartisanYSpace>
                <CartisanYSpace>
                    <div className={[Style.d_flex, Style.justify_content_center, Style.align_middle].join(" ")}>
                        <div  style={{width: '40%'}}
                            className={[    Style.vanilla_bg,
                                            Style.clickable,
                                            Style.rounded_2, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.fs_8, 
                                            Style.text_body,
                                            Style.text_center,
                                            Style.pop_item_animation].join(" ")}
                            onClick={() => {NewRequest();}}
                        >
                            <div className={Style.py_2}>
                                {GetSystemLabel("Return")}
                            </div>
                        </div>
                    </div>
                </CartisanYSpace>                
              </React.Fragment>
            )}
          </div>
        </div>        
      </div>
    </React.Fragment>
  );

};

